<template>
	<a :href="itemLink" class="card course-card block h-full">
		<div class="card-media" v-waves.block.light>
			<img class="card-media-image" :src="item.preview" alt="" v-if="item.preview">
			<card-status :item="item"></card-status>
			<span class="card-label card-label-yellow card-label-floating">Course</span>
		</div>

		<div class="card-content">
			<h4 class="card-title">{{ item.title }}</h4>

			<div class="card-info small">
				<span class="card-info-item">
					<b>{{ item.lessonCount }}</b> Lesson<template v-if="item.lessonCount !== 1">s</template>
				</span>
				<span class="card-info-item card-info-item-thin" v-if="item.is_started && !item.is_completed">
					{{ item.percentComplete }} Complete
				</span>
			</div>

			<div class="card-actions">
				<!-- <favorite-toggle :item="item" entity-type="course"></favorite-toggle> -->
			</div>
		</div>
	</a>
</template>

<script>
import ListItem from '../mixins/base-list-item';

export default {
	mixins: [ListItem],

	computed: {
		itemLink() {
			return '/courses/' + this.item.slug;
		}
	}
}
</script>
